<template>
  <div class="form-row align-items-start">
    <div class="form-group col-md-3 mb-3">
      <label class="labelTitle">Country</label>
      <Multiselect
        v-if="countries"
        v-model="country"
        :options="countries"
        :disabled="isSearching"
        :searchable="true"
        selectLabel=""
        placeholder="Select one"
        label="text"
        track-by="value"
        @select="selectingCountry"
        @remove="removingCountry" />
    </div>
    <div class="form-group col-md-3 mb-3">
      <label class="labelTitle">City or Landmark</label>
      <Multiselect
        :disabled="isSearching || !country"
        v-model="city"
        :options="cities"
        label="text"
        track-by="value"
        selectLabel=""
        placeholder="Type to search"
        open-direction="bottom"
        :searchable="true"
        :allowEmpty="true"
        :loading="searchingCities"
        :internal-search="false"
        :clear-on-select="false"
        :options-limit="300"
        :max-height="200"
        :show-no-results="false"
        :hide-selected="false"
        @search-change="searchCities"
        deselectLabel="Press to remove" />
    </div>
    <div class="form-group col-md-3 mb-3" v-if="false">
      <BaseInputForm
        label="Keyword"
        placeholder="Keyword"
        :disabled="isSearching"
        v-model="keyword" />
    </div>
    <div class="form-group col-md-6 mtop d-flex justify-content-between">
      <button style="position: relative;top: 0;height: 40px;" id="search-assets" type="button" class="btn btn-md btn-secondary btn-sm mr-2" :disabled="isSearching" @click="search">
        <font-awesome-icon :icon="['fas', 'search']" v-if="!isSearching" />
        <font-awesome-icon v-else class="text-white" :icon="['fas', 'spinner']" spin />
        Search
      </button>
      <button style="position: relative;top: 0;height: 40px;" type="button" class="btn btn-sm btn-secondary" :disabled="isSearching" @click="upload">
        <font-awesome-icon :icon="['fas', 'plus-circle']" />
        Upload
      </button>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
  name: 'ImagePickerSearch',
  components: { Multiselect },
  data () {
    return {
      country: this.defaultParams.country || '',
      city: this.defaultParams.city || '',
      keyword: '',
      searchingCities: false,
      cities: this.defaultParams.city ? [ this.defaultParams.city ] : []
    }
  },
  props: {
    countries: {
      type: [String, Array],
      required: false
    },
    isSearching: {
      type: Boolean,
      required: true
    },
    defaultParams: {
      type: Object,
      required: false
    }
  },
  methods: {
    cleanSearch (option) {
      this.country = { text: option.text, value: option.value }
      this.city = ''
      this.keyword = ''
    },
    selectingCountry (selectedOption) {
      this.cleanSearch(selectedOption)
    },
    removingCountry (removedOption) {
      this.cleanSearch(removedOption)
    },
    searchCities (query) {
      const minLength = 4
      if (query !== '' && query.length >= minLength) {
        const country = this.country.value
        const payload = { country, query }
        this.searchingCities = true
        this.$store.dispatch('location/searchCities', payload)
          .then(response => {
            if (Array.isArray(response) && response.length > 0) {
              this.cities = []
              this.cities = response
              this.searchingCities = false
            } else {
              this.cities = []
              this.searchingCities = false
            }
          })
          .catch(error => {
            console.log(error)
            this.cities = []
            this.searchingCities = false
          })
      }
    },
    search () {
      const params = {
        limit: 21,
        offset: 0,
        w: 150,
        h: 150,
        country: this.country,
        city: this.city,
        search: this.keyword
      }
      this.$emit('onSearch', params)
    },
    upload () {
      this.$parent.uploading = !this.$parent.uploading
    }
  }
}
</script>

<style lang="scss" scoped>
.mtop {
  margin-top: 25px;
}
</style>
